import Categorize from "../quiz/Categorize";
import FillInTheBlank from "../quiz/FillINTheBlank";
import Matching from "../quiz/Matching";
import NavBar from "../navBar/NavBar";
import PageTypeSelector from "../pageTypeSelector/PageTypeSelector";
import Reorder from "../quiz/Reorder";
import ShortAnswer from "../quiz/ShortAnswer";
import Test from "../quiz/Test";
import { UUID } from "crypto";
import { useState } from "react";
import SlidePage from "../slide/SlidePage";
import Drawing from "../quiz/Drawing";
import Labeling from "../quiz/Labeling";
import Poll from "../quiz/Poll";

type QuestionSettingsProps = {
  selectedPage: ActivityPage;
  updateSelectedQuizPage: Function;
  activityType: ActivityType;
  quizTypes?: SelectItem[];
  slideTypes?: SelectItem[];
  getTotalTime: Function;
  getTotalPoints: Function;
  selectedPageIndex: number;
  updateSelectedSlidePage: Function;
  session: Session;
  isDesktopOrLaptop?: boolean;
};
export function detectQuestionDirection(value: string): string {
  if (value) {
    const isRTL = /[\u0600-\u06FF\u0750-\u077F/؟]/.test(value);
    if (isRTL) {
      return "rtl";
    } else {
      return "ltr";
    }
  } else {
    return "rtl";
  }
}
export default function QuestionSettings({
  selectedPage,
  updateSelectedQuizPage,
  activityType,
  quizTypes,
  slideTypes,
  getTotalTime,
  getTotalPoints,
  selectedPageIndex,
  updateSelectedSlidePage,
  session,
  isDesktopOrLaptop,
}: QuestionSettingsProps) {
  const [questionDirection, setQuestionDirection] = useState("rtl");

  const updatePageType = (pageType: string) => {
    let quizDetails: QuizDetail[] | undefined =
      selectedPage.quiz_page.length === 0 ||
      selectedPage.quiz_page[0].quiz_detail_json === undefined
        ? undefined
        : [...selectedPage.quiz_page[0].quiz_detail_json];

    if (pageType === "multiple_choice") {
      if (quizDetails === undefined) {
        let initTestQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer1`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice2`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer2`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initTestQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length === 1) {
        while (quizDetails.length < 2) {
          quizDetails.push({
            id: `choice${quizDetails.length + 1}`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer${quizDetails.length + 1}`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          });
        }
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length >= 4) {
        const details = quizDetails.slice(0, 4);
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: details,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (
        quizDetails !== undefined &&
        (quizDetails.length >= 2 || quizDetails.length <= 4)
      ) {
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      }
    } else if (pageType === "matching") {
      if (quizDetails === undefined) {
        let initQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer1`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice2`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer2`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice3`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 3,
            correctOrder: 3,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer3`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice4`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 4,
            correctOrder: 4,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer4`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length === 1) {
        let updatedQuizDetails = [...quizDetails];
        while (updatedQuizDetails.length < 4) {
          updatedQuizDetails.push({
            id: `choice${updatedQuizDetails.length + 1}`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: updatedQuizDetails.length,
            correctOrder: updatedQuizDetails.length,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer${updatedQuizDetails.length + 1}`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          });
        }

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: updatedQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length > 4) {
        const details = quizDetails.slice(0, 4);
        const finalUpdate = details.map((detail) => {
          if (detail.answers?.length !== 1) {
            return {
              ...detail,
              answers: [
                {
                  id: `answer${detail.ordering}`,
                  answer: {
                    fileId: detail.answers?.[0]?.answer?.fileId || "",
                    text: detail.answers?.[0]?.answer?.text || "",
                    url: detail.answers?.[0]?.answer?.url || "",
                  },
                },
              ],
            };
          }
          return detail;
        });
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: finalUpdate,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (
        quizDetails !== undefined &&
        (quizDetails.length >= 2 || quizDetails.length <= 4)
      ) {
        const finalUpdate = quizDetails.map((detail) => {
          if (detail.answers?.length !== 1) {
            return {
              ...detail,
              answers: [
                {
                  id: `answer${detail.ordering}`,
                  answer: {
                    fileId: detail.answers?.[0]?.answer?.fileId || "",
                    text: detail.answers?.[0]?.answer?.text || "",
                    url: detail.answers?.[0]?.answer?.url || "",
                  },
                },
              ],
            };
          }
          return detail;
        });
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: finalUpdate,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else {
        const finalUpdate = quizDetails.map((detail, index) => {
          if (
            detail.answers?.length !== 1 ||
            !detail.answers[0]?.answer?.text
          ) {
            return {
              ...detail,
              choice: {
                ...detail.choice,
                text: detail.choice?.text || "",
              },
              answers: [
                {
                  id: `answer${index + 1}`,
                  answer: {
                    fileId: detail.answers?.[0]?.answer?.fileId || "",
                    text: detail.answers?.[0]?.answer?.text || "",
                    url: detail.answers?.[0]?.answer?.url || "",
                  },
                },
              ],
            };
          }
          return detail;
        });
        if (JSON.stringify(finalUpdate) !== JSON.stringify(quizDetails)) {
          updateSelectedQuizPage({
            type: "update_page_type",
            pageNumber: selectedPageIndex,
            data: {
              quizDetails: finalUpdate,
              pageType: pageType,
            },
            quizTypes: quizTypes,
          });
        }
      }
    } else if (pageType === "reorder") {
      if (quizDetails === undefined) {
        let initQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer1`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice2`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer2`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice3`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 3,
            correctOrder: 3,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer3`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice4`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 4,
            correctOrder: 4,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer4`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length === 1) {
        let updatedQuizDetails = [...quizDetails];
        while (updatedQuizDetails.length < 4) {
          updatedQuizDetails.push({
            id: `choice${updatedQuizDetails.length + 1}`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: updatedQuizDetails.length,
            correctOrder: updatedQuizDetails.length,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer${updatedQuizDetails.length + 1}`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          });
        }
        let sortedQuizDetail: QuizDetail[] = updatedQuizDetails.map(
          (detail, index) => ({
            ...detail,
            correctOrder: index + 1,
            ordering: index + 1,
          }),
        );
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: sortedQuizDetail,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length >= 8) {
        const details: QuizDetail[] = quizDetails
          .map((detail, index) => ({
            ...detail,
            correctOrder: index + 1,
            ordering: index + 1,
          }))
          .slice(0, 8);
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: details,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (
        quizDetails !== undefined &&
        (quizDetails.length >= 2 || quizDetails.length <= 8)
      ) {
        let sortedQuizDetail: QuizDetail[] = quizDetails.map(
          (detail, index) => ({
            ...detail,
            correctOrder: index + 1,
            ordering: index + 1,
          }),
        );
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: sortedQuizDetail,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      }
    } else if (pageType === "fill_in_the_blank") {
      let initQuizDetails: QuizDetail[] = [
        {
          id: `choice1`,
          choice: {
            fileId: "",
            text: "",
            url: "",
          },
          isCorrect: false,
          ordering: 1,
          correctOrder: 0,
          letterWise: true,
          isChoice: false,
          answers: [
            {
              id: `answer1`,
              answer: {
                fileId: "",
                text: "",
                url: "",
              },
            },
          ],
        },
      ];
      updateSelectedQuizPage({
        type: "update_page_type",
        pageNumber: selectedPageIndex,
        data: {
          quizDetails: initQuizDetails,
          pageType: pageType,
        },
        quizTypes: quizTypes,
      });
    } else if (pageType === "short_answer") {
      let initTestQuizDetails: QuizDetail[] = [
        {
          id: `choice1`,
          choice: {
            fileId: "",
            text: "",
            url: "",
          },
          isCorrect: false,
          ordering: 1,
          correctOrder: 1,
          letterWise: false,
          isChoice: true,
          answers: [
            {
              id: `answer1`,
              answer: {
                fileId: "",
                text: "",
                url: "",
              },
            },
          ],
        },
      ];
      updateSelectedQuizPage({
        type: "update_page_type",
        pageNumber: selectedPageIndex,
        data: {
          quizDetails: initTestQuizDetails,
          pageType: pageType,
        },
        quizTypes: quizTypes,
      });
    } else if (pageType === "categorize") {
      if (quizDetails === undefined) {
        let initCategorizeQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: "answer11",
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
              {
                id: "answer12",
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice2`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: "answer21",
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
              {
                id: "answer22",
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initCategorizeQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length === 1) {
        let updatedQuizDetails = [...quizDetails];
        while (updatedQuizDetails.length < 2) {
          updatedQuizDetails.push({
            id: `choice${updatedQuizDetails.length + 1}`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: updatedQuizDetails.length + 1,
            correctOrder: updatedQuizDetails.length + 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: "answer" + (updatedQuizDetails.length + 1) + 1,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
              {
                id: "answer" + (updatedQuizDetails.length + 1) + 2,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          });
        }
        const finalUpdate: QuizDetail[] = updatedQuizDetails.map(
          (detail, index) => {
            if (detail.answers && detail.answers?.length === 1) {
              return {
                ...detail,
                answers: [
                  ...detail.answers,
                  {
                    id: "answer" + (index + 1) + 2,
                    answer: { fileId: "", text: "", url: "" },
                  },
                ],
              };
            } else if (detail.answers && detail.answers?.length > 3) {
              return {
                ...detail,
                answers: detail.answers.slice(0, 3),
              };
            }

            return detail;
          },
        );

        let lastUpdated: QuizDetail[] = finalUpdate.map((detail, index) => {
          const newAnswers = detail.answers.map((answer, i) => {
            return { ...answer, id: "answer" + (index + 1) + (i + 1) };
          });
          return { ...detail, answers: newAnswers };
        });

        if (JSON.stringify(lastUpdated) !== JSON.stringify(quizDetails)) {
          updateSelectedQuizPage({
            type: "update_page_type",
            pageNumber: selectedPageIndex,
            data: {
              quizDetails: lastUpdated,
              pageType: pageType,
            },
            quizTypes: quizTypes,
          });
        }
      } else if (quizDetails.length >= 3) {
        const details = quizDetails.slice(0, 3);
        const finalUpdate: QuizDetail[] = details.map((detail, index) => {
          if (detail.answers && detail.answers?.length === 1) {
            return {
              ...detail,
              answers: [
                ...detail.answers,
                {
                  id: "answer" + (index + 1) + 2,
                  answer: { fileId: "", text: "", url: "" },
                },
              ],
            };
          } else if (detail.answers && detail.answers?.length > 3) {
            return {
              ...detail,
              answers: detail.answers.slice(0, 3),
            };
          }

          return detail;
        });

        let lastUpdated: QuizDetail[] = finalUpdate.map((detail, index) => {
          const newAnswers = detail.answers.map((answer, i) => {
            return { ...answer, id: "answer" + (index + 1) + (i + 1) };
          });
          return { ...detail, answers: newAnswers };
        });

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: lastUpdated,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (
        quizDetails !== undefined &&
        (quizDetails.length >= 2 || quizDetails.length <= 3)
      ) {
        const finalUpdate: QuizDetail[] = quizDetails.map((detail, index) => {
          if (detail.answers?.length === 1) {
            return {
              ...detail,
              answers: [
                ...detail.answers,
                {
                  id: "answer" + (index + 1) + 2,
                  answer: { fileId: "", text: "", url: "" },
                },
              ],
            };
          } else if (detail.answers && detail.answers?.length > 3) {
            return {
              ...detail,
              answers: detail.answers.slice(0, 3),
            };
          }
          return detail;
        });

        let lastUpdated: QuizDetail[] = finalUpdate.map((detail, index) => {
          const newAnswers = detail.answers.map((answer, i) => {
            return { ...answer, id: "answer" + (index + 1) + (i + 1) };
          });
          return { ...detail, answers: newAnswers };
        });

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: lastUpdated,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else {
        const finalUpdate: QuizDetail[] = quizDetails.map((detail, index) => {
          if (detail.answers && detail.answers?.length === 1) {
            return {
              ...detail,
              answers: [
                ...detail.answers,
                {
                  id: "answer" + (index + 1) + 2,
                  answer: { fileId: "", text: "", url: "" },
                },
              ],
            };
          } else if (detail.answers && detail.answers?.length > 3) {
            return {
              ...detail,
              answers: detail.answers.slice(0, 3),
            };
          }

          return detail;
        });
        let lastUpdated: QuizDetail[] = finalUpdate.map((detail, index) => {
          const newAnswers = detail.answers.map((answer, i) => {
            return { ...answer, id: "answer" + (index + 1) + (i + 1) };
          });
          return { ...detail, answers: newAnswers };
        });
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: lastUpdated,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      }
    } else if (
      pageType === "image_only" ||
      pageType === "video_only" ||
      pageType === "text_only" ||
      pageType === "text_slide"
    ) {
      updateSelectedSlidePage({
        type: "update_slide_type",
        pageNumber: selectedPageIndex,
        data: {
          pageType: pageType,
        },
        slideTypes: slideTypes,
      });
      // updateSelectedSlidePage
    } else if (pageType === "drawing") {
      if (quizDetails === undefined) {
        let initTestQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer1`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice2`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer2`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initTestQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length === 1) {
        while (quizDetails.length < 2) {
          quizDetails.push({
            id: `choice${quizDetails.length + 1}`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer${quizDetails.length + 1}`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          });
        }
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length >= 4) {
        const details = quizDetails.slice(0, 4);
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: details,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (
        quizDetails !== undefined &&
        (quizDetails.length >= 2 || quizDetails.length <= 4)
      ) {
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      }

    }else if (pageType === "poll") {
      if (quizDetails === undefined) {
        let initTestQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer1`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
          {
            id: `choice2`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer2`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initTestQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length === 1) {
        while (quizDetails.length < 2) {
          quizDetails.push({
            id: `choice${quizDetails.length + 1}`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 2,
            correctOrder: 2,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer${quizDetails.length + 1}`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          });
        }
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (quizDetails.length >= 4) {
        const details = quizDetails.slice(0, 4);
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: details,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else if (
        quizDetails !== undefined &&
        (quizDetails.length >= 2 || quizDetails.length <= 4)
      ) {
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      }
    } else if (pageType === "labeling") {
      if (quizDetails === undefined) {
        let initTestQuizDetails: QuizDetail[] = [
          {
            id: `choice1`,
            choice: {
              fileId: "",
              text: "",
              url: "",
            },
            isCorrect: false,
            ordering: 1,
            correctOrder: 1,
            letterWise: false,
            isChoice: true,
            answers: [
              {
                id: `answer1`,
                answer: {
                  fileId: "",
                  text: "",
                  url: "",
                },
              },
            ],
          },
        ];

        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: initTestQuizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      } else {
        updateSelectedQuizPage({
          type: "update_page_type",
          pageNumber: selectedPageIndex,
          data: {
            quizDetails: quizDetails,
            pageType: pageType,
          },
          quizTypes: quizTypes,
        });
      }
    }
  };

  const updatePagePoints = (pointsItem: SelectItem) => {
    const points = pointsItem?.code ? parseInt(pointsItem?.code) : null;
    updateSelectedQuizPage({
      type: "update_page_points",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      pageNumber: selectedPageIndex,

      data: { points },
    });
    getTotalPoints();
  };

  const updatePageTime = (timeItem: SelectItem) => {
    const time = timeItem?.code ? parseInt(timeItem?.code) : null;
    updateSelectedQuizPage({
      type: "update_page_time",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      pageNumber: selectedPageIndex,

      data: { time },
    });
    getTotalTime();
  };

  const updatePageQuiz = (quiz: Quiz) => {
    updateSelectedQuizPage({
      type: "update_page_quiz",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      data: quiz,
      quizTypes: quizTypes,
    });
  };

  const updateQuizDetail = (choice: QuizDetail) => {
    updateSelectedQuizPage({
      type: "update_choice",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      data: choice,
      quizTypes: quizTypes,
      choiceID: choice.id,
    });
  };

  const addNewChoice = (choice: QuizDetail, index: number) => {
    updateSelectedQuizPage({
      type: "add_new_choice",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      data: choice,
      quizTypes: quizTypes,
      choiceID: choice.id,
      index: index,
    });
  };

  const removeChoice = (id: string) => {
    updateSelectedQuizPage({
      type: "remove_choice",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      data: undefined,
      quizTypes: quizTypes,
      choiceID: id,
    });
  };

  const addNewAnswer = (
    choice: QuizDetail,
    answerIndex: number,
    choiceIndex: number,
  ) => {
    updateSelectedQuizPage({
      type: "add_new_answer",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      data: choice,
      index: choiceIndex,
      answerIndex: answerIndex,
    });
  };

  const removeAnswer = (choiceIndex: number, answerIndex: number) => {
    updateSelectedQuizPage({
      type: "remove_answer",
      page_id: selectedPage?.quiz_page?.[0]?.id,
      data: undefined,
      index: choiceIndex,
      answerIndex: answerIndex,
    });
  };

  const updateSlideTitle = (text: string) => {
    updateSelectedSlidePage({
      type: "update_slide_title",
      page_id: selectedPage?.id,
      data: text,

      slideTypes: slideTypes,
    });
  };
  const updateSlideText = (text: string) => {
    updateSelectedSlidePage({
      type: "update_slide_text",
      page_id: selectedPage?.id,
      data: text,
      slideTypes: slideTypes,
    });
  };
  const updateSlideImage = (image: UUID, image_url: string) => {
    updateSelectedSlidePage({
      type: "update_slide_image",
      page_id: selectedPage?.id,
      data: {
        image: image,
        image_url: image_url,
      },
      slideTypes: slideTypes,
    });
  };
  const updateSlideVideo = (video: UUID, url: string) => {
    updateSelectedSlidePage({
      type: "update_slide_video",
      page_id: selectedPage?.id,
      data: {
        video: video,
        image_url: url,
      },
      slideTypes: slideTypes,
    });
  };
  const updateSlideVoice = (video: UUID, url: string) => {
    updateSelectedSlidePage({
      type: "update_slide_voice",
      page_id: selectedPage?.id,
      data: {
        voice: video,
        image_url: url,
      },
      slideTypes: slideTypes,
    });
  };
  if (selectedPage) {
    return (
      <div className="flex flex-col w-full gap-2 h-full">
        {(selectedPage.quiz_page.length > 0 &&
          selectedPage.quiz_page !== undefined &&
          selectedPage.quiz_page[0].quiz_type !== undefined) ||
        (selectedPage.slide_page.length > 0 &&
          selectedPage.slide_page !== undefined &&
          selectedPage.slide_page[0].slide_type !== undefined) ? (
          <NavBar
            type={activityType}
            selectedQuiz={
              selectedPage.quiz_page.length > 0
                ? selectedPage.quiz_page[0]
                : undefined
            }
            selectedSlide={
              selectedPage.slide_page.length > 0
                ? selectedPage.slide_page[0]
                : undefined
            }
            updatePageType={updatePageType}
            quizTypes={quizTypes}
            updatePagePoints={updatePagePoints}
            updatePageTime={updatePageTime}
            slideTypes={slideTypes}
            isDesktopOrLaptop={isDesktopOrLaptop}
          />
        ) : (
          <div className="w-full bg-bg-cards rounded-lg h-full">
            <PageTypeSelector
              type={activityType}
              updatePageType={updatePageType}
              isDesktopOrLaptop={isDesktopOrLaptop}
            />
          </div>
        )}
        {selectedPage.quiz_page && selectedPage.quiz_page.length > 0 ? (
          <div className="w-full h-full">
            <div className="w-full h-full">
            {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "poll")
                  ?.id && (
                <Poll
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "multiple_choice")
                  ?.id && (
                <Test
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "matching")?.id && (
                <Matching
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "reorder")?.id && (
                <Reorder
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "fill_in_the_blank")
                  ?.id && (
                <FillInTheBlank
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "short_answer")?.id && (
                <ShortAnswer
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "categorize")?.id && (
                <Categorize
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  addNewAnswer={addNewAnswer}
                  removeAnswer={removeAnswer}
                  questionDirection={questionDirection}
                />
              )}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "drawing")?.id && (
                <Drawing
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  addNewAnswer={addNewAnswer}
                  removeAnswer={removeAnswer}
                  questionDirection={questionDirection}
                />
              )}{" "}
              {selectedPage.quiz_page[0].quiz_type ===
                quizTypes!.find((type) => type.code === "labeling")?.id && (
                <Labeling
                  selectedQuiz={selectedPage.quiz_page[0]}
                  updateQuizDetail={updateQuizDetail}
                  addNewChoice={addNewChoice}
                  removeChoice={removeChoice}
                  updateQuestion={updatePageQuiz}
                  addNewAnswer={addNewAnswer}
                  removeAnswer={removeAnswer}
                  questionDirection={questionDirection}
                />
              )}
            </div>
          </div>
        ) : (
          <div className="flex w-full h-full">
            {selectedPage.slide_page.length > 0 && (
              <SlidePage
                selectedSlide={selectedPage.slide_page[0]}
                slide_type={selectedPage.slide_page[0].slide_type}
                session={session}
                slideTypes={slideTypes}
                updateTitle={updateSlideTitle}
                updateText={updateSlideText}
                updateImage={updateSlideImage}
                updateVideo={updateSlideVideo}
                updateVoice={updateSlideVoice}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}
